import React from 'react';

import classNames from 'classnames';
import { Classes } from '../../../../../shared/configs/componentsClasses';

interface InputValidationProps {
  /**
   * Set validation message
   */
  message?: string | undefined;
  /**
   * Optional for additional classes
   */
  additionalClasses?: string | undefined;
}

/**
 * Primary UI component for user interaction
 */
const InputValidation: React.FC<InputValidationProps> = ({
  message,
  additionalClasses,
  ...rest
}) => {
  const inputValidationClasses = [Classes.inputValidation.error, additionalClasses];
  return (
    <span role="alert" className={classNames(inputValidationClasses)} {...rest}>
      {message}
    </span>
  );
};

export default InputValidation;
